const path = require("path")

const config = {
  path: {
    dir: {
      src: path.join(__dirname, "../", "src"),
      dist: path.join(__dirname, "../", "dist")
    },
    src: {
      indexHTML: path.join(__dirname, "../", "index.html"),
      errorHTML: path.join(__dirname, "../", "error.html")
    },
    dist: {
      indexHTML: path.join(__dirname, "../", "dist", "index.html"),
      errorHTML: path.join(__dirname, "../", "dist", "error.html")
    }
  },
  polarisAccounts: [
    "http://access.auth.theplatform.com/data/Account/2705432691",
    "http://access.auth.theplatform.com/data/Account/2705433929",
    "http://access.auth.theplatform.com/data/Account/2707827175",
    "http://access.auth.theplatform.com/data/Account/2707827131"
  ],
  features: {
    xmlBacklog: {
      dev: true,
      test: true,
      prod: true
    },
    preIngest: {
      dev: true,
      test: true,
      prod: true
    },
    assetStatus: {
      dev: false,
      test: false,
      prod: false
    },
    providerList: {
      dev: true,
      test: true,
      prod: true
    },
    providerGroups: {
      dev: true,
      test: true,
      prod: true
    },
    templateManagement: {
      dev: true,
      test: false,
      prod: false
    },
    metadataRules: {
      dev: true,
      test: true,
      prod: true
    },
    tranformationRules: {
      dev: true,
      test: true,
      prod: false
    }
  }
}

module.exports = config



//////////////////
// WEBPACK FOOTER
// ./config/client.js
// module id = Hl88
// module chunks = 1